import {ChangeDetectorRef, Component} from "@angular/core";
import {NotificationService} from "../notification.service";

@Component({
    selector: "woa-footer-messages",
    templateUrl: "footer-messages.component.html"
})
export class FooterMessagesComponent {
    showDynamicMessages: boolean = false;

    constructor(public notificationService: NotificationService,
                private changeDetectorRef: ChangeDetectorRef) {
        notificationService.footerMessagesChanged$.subscribe(() => {
            this.showDynamicMessages = true;
            this.changeDetectorRef.detectChanges();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/notification/footer-messages/footer-messages.component.ts